import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { ChatMessage } from 'APP/store/Messages/Message/ChatMessage/ChatMessage';

import { MessageViewPageType } from '../../../Messages.types';
import { SystemMessageLayout } from '../../SystemMessageLayout/SystemMessageLayout';
import { useSystemPresenter } from './System.presenter';
import styles from './System.styles.m.css';
import { SystemMessage } from './SystemMessage/SystemMessage';

interface ISystemProps {
  message: ChatMessage;
  messageViewPageType: MessageViewPageType;
}

export const System: FC<ISystemProps> = observer(({ message, messageViewPageType }) => {
  const { presenter, systemMessageText } = useSystemPresenter(message);

  if (!systemMessageText) {
    return null;
  }

  if (presenter.renderItems) {
    return (
      <SystemMessageLayout
        message={message}
        className={classNames({
          [styles.alignedLeft]: presenter.isLeftAligned,
        })}
        messageViewPageType={messageViewPageType}
      >
        <span className={styles.text}>
          <SystemMessage
            message={message}
            renderItems={presenter.renderItems}
          />
        </span>
      </SystemMessageLayout>
    );
  }

  return (
    <SystemMessageLayout
      message={message}
      messageViewPageType={messageViewPageType}
    >
      <span
        className={styles.text}
        dangerouslySetInnerHTML={{ __html: systemMessageText }}
      />
    </SystemMessageLayout>
  );
});
